"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalanceParticularGroup = exports.useBalancesFullSectionList = void 0;
const react_1 = require("react");
const AssetAPILib_1 = require("../AssetAPI/AssetAPILib");
const BalancesFullProvider_1 = require("./BalancesFullProvider");
const Helpers_1 = require("./Helpers");
const useBalancesFullSectionList = (app_lang, isActive, merge_order_group, ignoreCache) => {
    const info = (0, BalancesFullProvider_1.useBalancesFull)(app_lang, isActive, merge_order_group, ignoreCache);
    return (0, react_1.useMemo)(() => {
        if (!info) {
            return undefined;
        }
        return (0, Helpers_1.mergeData)(info);
    }, [info]);
};
exports.useBalancesFullSectionList = useBalancesFullSectionList;
const getBalanceParticularGroup = (app_lang, type, page_token = "0", merge_order_group) => {
    return new AssetAPILib_1.AssetAPILib().getBalancesFullDetail({ app_lang: app_lang, type: type, page_token: page_token, merge_order_group });
};
exports.getBalanceParticularGroup = getBalanceParticularGroup;
